import React, {useEffect, useRef, useState} from "react"
import {Form} from "react-bootstrap"
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {maxLength, PasswordValidation, Required} from "../../../../utils/patterns";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import {notification} from "antd";
import PasswordInput from "../../../../components/common/password-field/PasswordInput";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import Heading from "../../../../components/dashboard/heading-component/Heading";
import {useJournal} from "../../../../providers/JournalContext";

export default function SetJournalPassword({close, getListing, setGetListing}) {
    const[loader,setLoader] = useState(false);
    const { setUpdateJournalProfile , updateJournalProfile} = useJournal()
    const { validateJournalPass, setValidateJournalPass,firstTimePassword, setFirstTimePassword} = useJournal()
    const navigate = useNavigate()

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors, isValid},
        control,
        watch,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })

    const password = useRef({})
    password.current = watch('password', '')

    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            let payload = {
                password: data.password,
                confirmPassword: data.cpassword
            }
            const response = await UserAuthService.ResetJournalPassword(payload)

            if (response?.data?.data?.status){

                notification.success({
                    message: "Success",
                    description: response.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                setLoader(false)
                setUpdateJournalProfile(!updateJournalProfile)
                setFirstTimePassword(false)
                navigate('/journals/validate-password')
            }
            // else{
            //     notification.error({
            //         message: "Failed",
            //         description: response.data?.data?.message,
            //         placement: "topRight",
            //         icon: <CloseRoundedCheck/>,
            //         duration: 2,
            //     });
            //     setLoader(false)
            // }
        }

    }

    useEffect(() => {
        if (firstTimePassword === true) {
            navigate('/journals/set-journal-password');
        } else if (validateJournalPass === true) {
            navigate('/journals/validate-password');
        }
    }, [firstTimePassword, validateJournalPass]);

    return(
        <div className={'align-content-center h-100'}>
            <div className={'validate-journals'}>
                <Heading heading={'Set Journal Password'} back={false}/>
                <p>Set your password to use your journals</p>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className={'dfields'}>
                        <Controller
                            name="password"
                            defaultValue={''}
                            control={control}
                            rules={{required: Required, pattern:PasswordValidation, maxLength: maxLength(100)}}
                            render={({field: {name, ...field}}) => (
                                <PasswordInput
                                    placeholder={'Enter new password here'}
                                    label={'New Password'}
                                    field={field}
                                    errors={errors.password}
                                    className={'required'}
                                />
                            )}
                        />
                    </div>
                    <div className={'dfields'}>
                        <Controller
                            name="cpassword"
                            defaultValue={''}
                            control={control}
                            rules={{
                                required: Required,
                                validate: (value) => value == password.current || 'The password does not match',
                            }}
                            render={({field: {name, ...field}}) => (
                                <PasswordInput
                                    placeholder={'Re-enter new password here'}
                                    label={'Re-enter New Password'}
                                    field={field}
                                    errors={errors.cpassword}
                                    className={'required'}
                                />
                            )}
                        />
                    </div>

                    <div className={'dfields mt-4'}>
                        <ThemeButton
                            text={'Update'}
                            className={'btn-light-lg'}
                            type={'submit'}
                            loader={loader}
                        />
                    </div>
                </Form>
            </div>
        </div>
    )
}